<template>
    <div class="mx-auto">
        <b-card>
            <b-row class="d-flex justify-content-between">
                <b-col>
                    <CompBotaoExibirOcultarColuna
                            :fields="fields"
                            :showColunms="showColunms"
                            @toggleColuna="toggleColuna"/>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col>
                    <b-form-select v-model="configTable.perPage" :options="[10, 100, 500, 1000, 'Todos']" size="sm"
                                   class="mb-3 col-2" style="float:right"></b-form-select>
                    <b-button class="ml-2" variant="secondary" @click="limparFiltros"
                              style="float: right; margin-right: 10px; height: 32px; padding: 0 0.75rem;">
                        <i class="fas fa-broom"></i> Limpar Filtros
                    </b-button>
                </b-col>
            </b-row>

            <b-table
                    id="regrasPagamento"
                    :items="resultado"
                    :fields="fields"
                    striped
                    small
                    :busy="configTable.load"
                    responsive
                    show-empty
                    hover
                    bordered
                    class="mb-0"
                    head-variant="light">
                <div slot="table-busy" class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Carregando...</strong>
                </div>
                <template slot="empty">
                    <p class="my-auto">Nenhum registro encontrado.</p>
                </template>
                <template v-slot:head(selecionar)="{ item }">
                    <b-form-checkbox v-model="configTable.checkedAll" class="justify-content-center text-center" @change="toggleAll" />
                </template>
                <template v-slot:cell(selecionar)="{ item }">
                    <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="selecteds.includes(item)" @change="toggleCheck($event, item)" />
                </template>
                <template v-slot:head(1)="{ item }">
                    Número Requisição <i class="filter" :class="!isEmpty(filtros.numeroRequisicao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Número Requisição', 'mascara', '', '#########', $event)"></i>
                </template>
                <template v-slot:cell(1)="{ item }">
                    <p class="text-center">
                        <a class="link" @click="abrirModalExtrato(item)">
                            {{ item.numeroRequisicao }}
                        </a>
                    </p>
                </template>
                <template v-slot:head(2)="{ item }">
                    Tipo Requisição <i class="filter" :class="!isEmpty(filtros.tipoRequisicacao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Tipo Requisição', 'checkbox', dados.tiposRequisicao, null, $event)"></i>
                </template>
                <template v-slot:cell(2)="{ item }">
                    {{ item.tabelaOrigem == 0 ? item.tipoRequisicao.nome + " - " + item.receita : item.receita }}
                </template>
                <template v-slot:head(3)="{ item }">
                    Processo <i class="filter" :class="!isEmpty(filtros.cnj) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Processo', 'mascara', '', 'cnj', $event)"></i>
                </template>
                <template v-slot:cell(3)="{ item }">
                    <p v-if="item.cnj.length == 1">
                        {{ item.cnj[0] }}
                    </p>
                    <p v-if="!item.abrirTodos && item.cnj.length > 1">
                        {{ item.cnj[0] }} <a class="link" @click="expandirOutros(item)">e outros</a>
                    </p>
                    <p v-for="cnj in item.cnj" v-if="item.abrirTodos && item.cnj.length > 1">
                        {{ cnj }}
                    </p>
                </template>
                <template v-slot:head(4)="{ item }">
                    Devedor <i class="filter" :class="!isEmpty(filtros.contribuinte) || filtros.filtrarContribuinte == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Devedor', 'texto', '', null, $event)"></i>
                </template>
                <template v-slot:cell(4)="{ item }">
                    {{ item.devedor }}
                </template>
                <template v-slot:head(5)="{ item }">
                    Valor <i class="filter" :class="!isEmpty(filtros.valor) || filtros.filtrarValor == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Valor', 'numerico', '', null, $event)"></i>
                </template>
                <template v-slot:cell(5)="{ item }">
                    <p class="text-right" v-if="item.valor != null">
                        {{ item.valor | currency }}
                    </p>
                </template>
                <template v-slot:head(6)="{ item }">
                    Data Transf. <i class="filter" :class="!isEmpty(filtros.dataTransferencia) || filtros.filtrarDataTransferencia == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Data Transf.', 'data', '', null, $event)"></i>
                </template>
                <template v-slot:cell(6)="{ item }">
                    <p class="text-center">
                        {{ item.dataTransferencia }}
                    </p>
                </template>
                <template v-slot:head(7)="{ item }">
                    Usuário Responsável <i class="filter" :class="!isEmpty(filtros.usuarioInclusao) || filtros.filtrarUsuarioInclusao == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Usuário Responsável', 'texto', '', null, $event)"></i>
                </template>
                <template v-slot:cell(7)="{ item }">
                    {{ item.usuarioInclusao }}
                </template>
                <template v-slot:head(8)="{ item }">
                    Setor <i class="filter" :class="!isEmpty(filtros.setor) || filtros.filtrarSetor == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Setor', 'texto', '', null, $event)"></i>
                </template>
                <template v-slot:cell(8)="{ item }">
                    {{ item.setor }}
                </template>
                <template v-slot:head(9)="{ item }">
                    Observações <i class="filter" :class="!isEmpty(filtros.observacoes) || filtros.filtrarObservacoes == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Observações', 'texto', '', null, $event)"></i>
                </template>
                <template v-slot:cell(9)="{ item }">
                    {{ item.observacoes }}
                </template>
                <template v-slot:head(10)="{ item }">
                    Documentos Anexos <i class="filter" :class="!isEmpty(filtros.documentos) || filtros.filtrarDocumentos == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Documentos Anexos', 'texto', '', null, $event)"></i>
                </template>
                <template v-slot:cell(10)="{ item }">
                    <p>
                        <a class="link" v-for="(anexo, index) in item.anexos" @click="obterAnexo(anexo)">
                            <span v-if="index > 0">, </span>
                            {{ anexo.nomeAnexo }}
                        </a>
                    </p>
                </template>
                <template v-slot:head(11)="{ item }">
                    Validação GOFS <i class="filter" :class="!isEmpty(filtros.validacaoGofs) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Validação GOFS', 'checkbox', validacoes, null, $event)"></i>
                </template>
                <template v-slot:cell(11)="{ item }">
                    <p :style="'color: ' + (item.validacaoGofs !== null && item.validacaoGofs ? 'blue' : (item.validacaoGofs !== null ? 'red' : 'orange'))">
                        {{ (item.validacaoGofs !== null && item.validacaoGofs ? 'VALIDADA' : (item.validacaoGofs !== null ? 'CANCELADA' : 'AGUARDANDO')) }}
                    </p>
                </template>
                <template v-slot:head(12)="{ item }">
                    Validação Tesoureiro <i class="filter" :class="!isEmpty(filtros.validacaoTesoureiro) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Validação Tesoureiro', 'checkbox', validacoes, null, $event)"></i>
                </template>
                <template v-slot:cell(12)="{ item }">
                    <p :style="'color: ' + (item.validacaoTesoureiro !== null && item.validacaoTesoureiro ? 'blue' : (item.validacaoTesoureiro !== null ? 'red' : 'orange'))">
                        {{ (item.validacaoTesoureiro !== null && item.validacaoTesoureiro ? 'VALIDADA' : (item.validacaoTesoureiro !== null ? 'CANCELADA' : 'AGUARDANDO')) }}
                    </p>
                </template>
            </b-table>

            <b-row class="d-flex justify-content-between" style="margin-top: 10px;">
                <b-col>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col>
                    <div class="registros-encontrados">
                        <span>Requisições Encontradas:</span>
                    </div>
                    <div class="registros-encontrados-valor">
                        <span>{{configTable.perPage != 'Todos' ? configTable.rows : resultado.length}}</span>
                    </div>

                    <div class="registros-encontrados" style="margin-left: 15px">
                        <span>Requisições Selecionadas</span>
                    </div>
                    <div class="registros-encontrados-valor">
                        <span>{{selecteds.length}}</span>
                    </div>
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col md="12">
                    <div class="d-flex justify-content-between align-items-center">
                        <div style="margin: auto">
                            <b-button class="ml-2" variant="primary" v-if="!filtros.aprovadasReprovadas" @click="limparModal" v-b-modal.modal-aprovar-gofs :disabled="selecteds.length < 1 || !habilitarValidarGofs">
                                <i class="fas fa-check"></i> GOFS - Validar
                            </b-button>
                            <b-button class="ml-2" variant="primary" v-if="!filtros.aprovadasReprovadas && (tesoureiro || admin)" @click="limparModal" v-b-modal.modal-aprovar-tesoureiro :disabled="selecteds.length < 1 || !habilitarValidarTesoureiro">
                                <i class="fas fa-check"></i> Tesoureiro - Validar
                            </b-button>
                            <b-button class="ml-2" variant="primary" v-if="!filtros.aprovadasReprovadas && !gofs" @click="limparModal" v-b-modal.modal-alterar-valor :disabled="selecteds.length < 1">
                                <i class="fa fa-pen"></i> Alterar Valor
                            </b-button>
                            <b-button class="ml-2" variant="primary" v-if="!filtros.aprovadasReprovadas && !admin" @click="limparModal" v-b-modal.modal-invalidar :disabled="selecteds.length < 1">
                                <i class="fa fa-times"></i> Invalidar
                            </b-button>
                            <b-button class="ml-2" variant="primary" v-if="!filtros.aprovadasReprovadas" @click="listarAprovadasReprovadas">
                                <i class="fas fa-edit"></i> Ver Req. Aprovadas/Reprovadas
                            </b-button>
                            <b-button class="ml-2" variant="primary" v-if="filtros.aprovadasReprovadas" @click="listarPendentes">
                                <i class="fas fa-edit"></i> Ver Req. Aguardando Validação
                            </b-button>
                            <b-button class="ml-2" variant="primary" @click="exportar">
                                <i class="fa fa-table"></i> Exportar CSV
                            </b-button>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-modal
                    ref="modal-aprovar-gofs"
                    id="modal-aprovar-gofs"
                    size="xl"
                    :content-class="'shadow ' + getTheme"
                    title="Aprovar a Requisição - GOFS"
                    header-bg-variant="success"
                    header-text-variant="white">
                <b-row class="mt-3">
                    <b-col xs="12" md="12" class="mx-auto">
                        <p style="font-weight: bold;">Deseja aprovar a(s) requisição(ões)?</p>
                    </b-col>
                </b-row>
                <template v-slot:modal-footer="{ hide }">
                    <b-button variant="secondary" @click="hide('modal-aprovar-gofs')"> Voltar</b-button>
                    <b-button variant="primary" @click="aprovarGofs"> Confirmar</b-button>
                </template>
            </b-modal>
            <b-modal
                    ref="modal-aprovar-tesoureiro"
                    id="modal-aprovar-tesoureiro"
                    size="xl"
                    :content-class="'shadow ' + getTheme"
                    title="Aprovar a Requisição - Tesoureiro"
                    header-bg-variant="success"
                    header-text-variant="white">
                <b-row class="mt-3">
                    <b-col xs="12" md="12" class="mx-auto">
                        <p style="font-weight: bold;">Deseja aprovar a(s) requisição(ões)?</p>
                    </b-col>
                </b-row>
                <template v-slot:modal-footer="{ hide }">
                    <b-button variant="secondary" @click="hide('modal-aprovar-tesoureiro')"> Voltar</b-button>
                    <b-button variant="primary" @click="aprovarTesoureiro"> Confirmar</b-button>
                </template>
            </b-modal>
            <b-modal
                    ref="modal-alterar-valor"
                    id="modal-alterar-valor"
                    size="xl"
                    :content-class="'shadow ' + getTheme"
                    title="Alterar Valor"
                    header-bg-variant="success"
                    header-text-variant="white">
                <b-row class="mt-3">
                    <b-col xs="12" md="12" class="mx-auto">
                        <div id="messages" v-if="messageModal !== null">
                            <b-alert show variant="danger">{{ messageModal }}</b-alert>
                        </div>
                    </b-col>
                    <b-col xs="12" md="12" class="mx-auto">
                        <b-row class="mt-1 mb-0">
                            <b-col sm="12" md="4">
                                <b-form-group
                                        label="Valor (R$):"
                                        label-for="valor"
                                        >
                                    <b-form-input v-model="valor" type="text" id="valorminparc"
                                     @keyup="valor = formatarMonetario(valor)"
                                     :class="!validations.valorminparc.valid ? 'is-invalid' : ''"
                                     @change="validarValor"></b-form-input>
                     <b-row>
                     <b-col sm="12" md="12">
                       <div v-if="!validations.valorminparc.valid" class="invalid-message">Não é permitida a emissão de Requisição de valor zero ou negativo.</div>
                    </b-col>
                    </b-row>                     
                                                  
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="mt-1 mb-0">
                            <b-col>
                                <b-form-group
                                        label="Observações"
                                        class="text-label required"
                                        label-for="textarea-formatter">
                                        
                                       
                                    <b-form-textarea
                                            id="observacoes"
                                            v-model="observacoes"
                                            size="500"
                                            placeholder=""
                                            max-rows="10"
                                            :class="'text-label required ' + (!paymentValidations.observacoes.valid ? 'is-invalid' : '')">
                                    ></b-form-textarea>
                                    
                                    <b-row>
                                    <b-col sm="12" md="12">
                                    <div v-if="!paymentValidations.observacoes.valid" class="invalid-message">Campo Obrigatório.</div>
                                   </b-col>
                                   </b-row> 
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <template v-slot:modal-footer="{ hide }">
                    <b-button variant="secondary" @click="hide('modal-alterar-valor')"> Voltar</b-button>
                    <b-button variant="primary" @click="alterarValor"> Confirmar</b-button>
                </template>
            </b-modal>
            <b-modal
                    ref="modal-invalidar"
                    id="modal-invalidar"
                    size="xl"
                    :content-class="'shadow ' + getTheme"
                    title="Invalidar Requisição"
                    header-bg-variant="success"
                    header-text-variant="white">
                <b-row class="mt-3">
                    <b-col xs="12" md="12" class="mx-auto">
                        <div id="messages" v-if="messageModal !== null">
                            <b-alert show variant="danger">{{ messageModal }}</b-alert>
                        </div>
                    </b-col>
                    <b-col xs="12" md="12" class="mx-auto">
                        <b-row class="mt-1 mb-0">
                            <b-col>
                                <b-form-group
                                        label="Motivo"
                                        class="text-label required"
                                        label-for="textarea-formatter">
                                    <b-form-textarea
                                            id="observacoes"
                                            v-model="observacoes"
                                            size="500"
                                            placeholder=""
                                            max-rows="10"
                                    ></b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <template v-slot:modal-footer="{ hide }">
                    <b-button variant="secondary" @click="hide('modal-invalidar')"> Voltar</b-button>
                    <b-button variant="primary" @click="invalidar"> Confirmar</b-button>
                </template>
            </b-modal>
        </b-card>
    </div>
</template>

<script>
    import axios from 'axios'
    import formatarMixins from '../../../mixins/formatarMixins';
    import CompBotaoExibirOcultarColuna from "../../shared/components/CompBotaoExibirOcultarColuna";

    export default {
    props: ['resultado', 'configTable', 'filtroComponente', 'filtros', 'loading', 'selecteds'],
    components: {CompBotaoExibirOcultarColuna},
    mixins: [ formatarMixins ],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false;
            this.$emit('consultar');
        },
        perPage() {
            this.configTable.currentPage = 1;
            this.$emit('consultar');
        }
    },
    data() {
        return {
            urlApi: null,
            token: null,
            messageModal: null,
            valor: null,
            observacoes: null,
            admin: false,
            gofs: false,
            tesoureiro: false,
            habilitarValidarTesoureiro: false,
            habilitarValidarGofs: false,
            showColunms: [],
            fields: [
                {
                    key: "selecionar",
                }
            ],
            validacoes: [{
              id: 0,
              nome: 'Aguardando'
            },{
              id: 1,
              nome: 'Cancelada'
            },{
              id: 2,
              nome: 'Validada'
            }],
            dados: {
                formasPagamento: null,
                tiposPagamento: null,
                statusRequisicao: null,
                tiposRequisicao: [
                    {id: 1, nome: "Honorários de Ação Judicial"},
                    {id: 4, nome: "Honorários de EF - Base de Cálculo D.A. SEFA"},
                    {id: 3, nome: "Honorários de Protesto"},
                    {id: 0, nome: "Receita Diversa"},
                ]
            },
            
             validations: {
                    valorminparc: {
                        valid: true,
                        
                    }
                    
                },
                
              paymentValidations: {
                    valorminparc: { valid: true, message: ""},
                    observacoes: { valid: true, message: ""}
                    
                },  
            
        }
    },
    computed: {
        getTheme () {
            return this.$store.getters.getTheme
        },
        currentPage() {
            return this.configTable.currentPage;
        },
        perPage() {
            return this.configTable.perPage;
        },
    },
    methods: {
        toggleAll(checked) {
            if(checked) {
                this.resultado.forEach(el => {
                    if(!this.selecteds.includes(el)) {
                        this.selecteds.push(el);
                    }
                })
            } else {
                this.resultado.forEach(el => {
                    if(this.selecteds.includes(el)) {
                        const index = this.selecteds.indexOf(el);
                        this.selecteds.splice(index, 1);
                    }
                })
            }

            this.verificarHabilitarGofsValidar();
            this.verificarHabilitarTesoureiroValidar();
        },
        toggleCheck(checked, item) {
            if(checked) {
                this.selecteds.push(item);
            } else {
                const index = this.selecteds.indexOf(item);
                this.selecteds.splice(index, 1);
                this.configTable.checkedAll = false;
            }

            this.verificarHabilitarGofsValidar();
            this.verificarHabilitarTesoureiroValidar();
        },
        async obterColunasUsuario() {
            const funcionalidade = 'requisicaoGofsTesoureiro';

            this.configTable.load = true;
            axios.get(`${this.urlApi}/v1/funcionalidade/configuracao/${funcionalidade}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                response.data.forEach((field, i) => {
                    if (field.ativo) {
                        this.showColunms.push(i + 1)
                    }
                    this.fields.push({
                        key: `${i + 1}`,
                        label: `${field.descricao}`,
                        thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                        codColunaFuncionalidade: field.codColunaFuncionalidade,
                        codFuncionalidade: field.codFuncionalidade
                    })
                })
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.configTable.load = false;
            })
        },

        toggleColuna(i) {
            let ativo;
            if (this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1);
                this.fields[i].thClass = 'd-none';
                this.fields[i].tdClass = 'd-none';
                ativo = false
            } else {
                this.showColunms.push(i);alterrvalidade
                this.fields[i].thClass = '';
                this.fields[i].tdClass = '';
                ativo = true
            }

            this.atualizarConfiguracaoColunm(i, ativo)
        },

        async atualizarConfiguracaoColunm(i, ativo) {
            const json = {
                codFuncionalidade: this.fields[i].codFuncionalidade,
                codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                ativo,
            };
            axios.put(`${this.urlApi}/v1/funcionalidade/configuracao`, json, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).catch((error) => {
                this.exibirErro(error)
            })
        },

        openFilter(campo, tipo, values, mask, event) {
            this.$emit('openFilterPopup', campo, tipo, values, mask, event);
        },

        exportar() {
            this.$emit('exportar', 'requisicaoGofsTesoureiro');
        },

        aprovar() {
            this.$refs['modal-aprovar'].hide();

            this.loading.showLoading();
            axios.post(`${this.urlApi}/v1/painelUsuario/aprovarRequisicao`, this.selecteds, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: [{message: 'Operação realizada com sucesso!!!'}]});
                this.$emit('limparSelect');
                this.$emit('consultar');
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.loading.hideLoading();
            });
        },

        cancelar() {
            this.$refs['modal-cancelar-painel'].hide();

            this.loading.showLoading();
            axios.post(`${this.urlApi}/v1/painelUsuario/reprovarRequisicao`, this.selecteds, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: [{message: 'Operação realizada com sucesso!!!'}]});
                this.$emit('limparSelect');
                this.$emit('consultar');
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.loading.hideLoading();
            });
        },

        verificarHabilitarGofsValidar() {
            if(this.selecteds.length > 0) {
                this.habilitarValidarGofs = true;
            } else {
                this.habilitarValidarGofs = false;
            }

            for(var i = 0; i < this.selecteds.length; i++) {
                if(this.selecteds[i].validacaoGofs != null) {
                    this.habilitarValidarGofs = false;
                    return;
                }
            }
        },
        verificarHabilitarTesoureiroValidar() {
            if(this.selecteds.length > 0) {
                this.habilitarValidarTesoureiro = true;
            } else {
                this.habilitarValidarTesoureiro = false;
            }

            for(var i = 0; i < this.selecteds.length; i++) {
                if(this.selecteds[i].validacaoTesoureiro != null) {
                    this.habilitarValidarTesoureiro = false;
                    return;
                }
            }
        },
        listarAprovadasReprovadas() {
            this.$emit('listarPorPendencia', true);
        },
        listarPendentes() {
            this.$emit('listarPorPendencia', false);
        },

        async aprovarGofs() {
            this.$refs['modal-aprovar-gofs'].hide();

            this.loading.showLoading();
            axios.post(`${this.urlApi}/v1/painelUsuario/validarGofs`, this.selecteds, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: [{message: 'Operação realizada com sucesso!!!'}]});
                this.$emit('limparSelect');
                this.$emit('consultar');
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.loading.hideLoading();
            })
        },

        async aprovarTesoureiro() {
            this.$refs['modal-aprovar-tesoureiro'].hide();

            this.loading.showLoading();
            axios.post(`${this.urlApi}/v1/painelUsuario/validarTesoureiro`, this.selecteds, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: [{message: 'Operação realizada com sucesso!!!'}]});
                this.$emit('limparSelect');
                this.$emit('consultar');
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.loading.hideLoading();
            })
        },

        async alterarValor() {
            if(this.validarValor(this.valor) ||
                this.validarValorObrigatorio(this.observacoes)) {                                  
                         
            
            
            this.$refs['modal-alterar-valor'].hide();

            let entity = {
                valor: this.tratarCamposNumericos(this.valor),
                observacoes: this.observacoes,
                listaObjetos: this.selecteds
            };

            this.loading.showLoading();
            axios.post(`${this.urlApi}/v1/painelUsuario/alterarValor`, entity, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: [{message: 'Operação realizada com sucesso!!!'}]});
                this.$emit('limparSelect');
                this.$emit('consultar');
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.loading.hideLoading();
            })
            
            }
            
        },

        async invalidar() {
            if(this.verificarValorVazio(this.observacoes)) {
                this.messageModal = 'Favor preencher o campo obrigatório (*)';
                return;
            }

            this.messageModal = null;

            this.$refs['modal-invalidar'].hide();

            let entity = {
                observacoes: this.observacoes,
                listaObjetos: this.selecteds
            };

            this.loading.showLoading();
            axios.post(`${this.urlApi}/v1/painelUsuario/invalidar`, entity, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: [{message: 'Operação realizada com sucesso!!!'}]});
                this.$emit('consultar');
                this.$emit('limparSelect');
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.loading.hideLoading();
            })
        },

        limparModal() {
            this.valor = null;
            this.observacoes = null;
            this.messageModal = null;
        },
        
        validarValor() {
                let valor = this.tratarCamposNumericos(this.valor)
                if(valor <= 0) {
                    this.$emit('alterarValidadeValor', false);
                    this.validations.valorminparc.valid=false;
                } else {
                    this.$emit('alterarValidadeValor', true);
                    this.validations.valorminparc.valid=true;
                }
                
            },
            
            
                alterarValidadeValor(valido) {
                this.validations.valor.valid = valido;
                this.validations.valor.mensagem = "Não é permitida a emissão de Requisição de valor zero ou negativo.";
            },
            
            validarValorObrigatorio() {
                let valor = this.tratarCamposNumericos(this.observacoes);
                if(this.observacoes == null) {
                    this.validarCampoObrigatorio(this.observacoes, this.paymentValidations.observacoes)
                    return this.paymentValidations.observacoes.valid=false;
                    
                    
                } else {
                    return this.paymentValidations.observacoes.valid=true;
                    
                }
                
                
            },
            
            

        abrirModalExtrato(item) {
            this.$emit('abrirExtrato', item);
        },
        async obterAnexo(anexo) {
            this.loading.showLoading();
            await axios.get(`${this.urlApi}/v1/pesquisas/downloadAnexo/${anexo.codAnexo}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            }).then(response => {
                if(!response.data || !response.data.byteLength){
                    this.$store.commit("setMessages", { message: 'Erro!', errors: ['Arquivo não encontrado para download.'] });
                    return;
                }

                let blob = new Blob([response.data], { type: 'application/pdf' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = anexo.nomeAnexo;
                link.click();
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.loading.hideLoading();
            });
        },

        limparFiltros() {
            this.$emit('limparFiltros');
        },
        expandirOutros(item) {
            item.abrirTodos = true;
        },
    },
    mounted() {
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.token = JSON.parse(this.$store.getters.getUser).access_token;

        this.obterColunasUsuario();

        let userData = JSON.parse(this.$store.getters.getUser);
        if (userData.groups) {
            for (let i = 0; i < userData.groups.length; i++) {
                if(userData.groups[i] == 'SFEPGE-ADMINISTRADOR') {
                    this.admin = true;
                } else if(userData.groups[i] == 'SFEPGE-GOFS') {
                    this.gofs = true;
                } else if(userData.groups[i] == 'SFEPGE-TESOUREIRO') {
                    this.tesoureiro = true;
                }
            }
        }
    }
    

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}
input:invalid {
    border-color: red;
}
input:invalid + span {
    color: red;
}

.icon-button {
    font-size: 1.5rem;
    margin-left: 1rem;
    padding: 0 0.5rem;
}
.icon-button i {
    color: inherit;
    vertical-align: middle;
}

</style>
